export default "__VITE_ASSET__DxBqjCNU__"